<template>
  <v-container fluid fill-height>
    <v-row>
      <v-col cols="10" offset="1">
        <v-row justify="center">
          <v-col cols="9">
            <h1 class="company-name display-3 pa-10 pb-3">
              <span class="font-weight-black">Vivid</span> Financing
            </h1>
            <v-sheet
              color="transparent"
              class="home-byline white--text py-1 mt-2 mb-6 font-weight-bold"
            >
              Lending based on the performance of your business, not
              the reputation of your industry.
            </v-sheet>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="3">
            <v-card>
              <v-card-title>Financing Options</v-card-title>
              <v-card-text class="text-left">
                There are hundreds of commercial financing programs available.
                We'll work to match you with the right ones.
              </v-card-text>
              <v-card-actions>
                <v-btn
                  color="primary"
                  to="/contact"
                >Contact Us</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="3">
            <v-card>
              <v-card-title>Restricted Industries</v-card-title>
              <v-card-text class="text-left">
                Unlike many, we don't discriminate based on your industry
                or the type of business you conduct.
              </v-card-text>
              <v-card-actions>
                <v-btn
                  color="secondary"
                  to="/loans"
                >Learn more</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="3">
            <v-card>
              <v-card-title>Reach Investors</v-card-title>
              <v-card-text class="text-left">
                If you need a substantial investment, investors in our
                network might be looking for a company like yours.
              </v-card-text>
              <v-card-actions>
                <v-btn
                  color="primary"
                  to="/investors"
                >Contact us</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
  h1.company-name {
    text-shadow: 2px 2px 6px #000000;
  }
  .home-byline {
    text-shadow: 2px 2px 10px #000000;
  }
</style>

<script>
export default {
  name: 'Home',
};
</script>
